export const ROOM_MODE_OPTIONS = {
  FURNISH_EMPTY_ROOM: {
    value: 'furnishEmptyRoom',
    description: 'furnishEmptyRoomDescription',
  },
  CHANGE_STYLE: { value: 'changeStyle', description: 'changeStyleDescription' },
  FURNITURE_REMOVAL: { value: 'furnitureRemoval', description: 'furnitureRemovalDescription' },
  FINISH_CONSTRUCTION: {
    value: 'finishConstruction',
    description: 'finishConstructionDescription',
  },
  CHANGE_FLOOR: { value: 'changeFloor', description: 'changeFloorDescription' },
  CLEAN_ROOM: { value: 'cleanRoom', description: 'cleanRoomDescription' },
  IMPROVE_IMAGE_QUALITY: {
    value: 'improveImageQuality',
    description: 'improveImageQualityDescription',
  },
  GOOD_WEATHER: {
    value: 'goodWeather',
    description: 'goodWeatherDescription',
  },
  ENHANCE_AND_UPSCALE: {
    value: 'enhanceAndUpscale',
    description: 'enhanceAndUpscaleDescription',
  },
  PHOTOREALISTIC_FROM_3D: {
    value: 'photorealisticFrom3D',
    description: 'photorealisticFrom3DDescription',
  },
} as const;

export const GOOD_WEATHER_DAYLIGHT_OPTIONS = [
  { value: 'day' as const, descriptionKey: 'goodWeatherDay' },
  { value: 'night' as const, descriptionKey: 'goodWeatherNight' },
] as const;

export const GOOD_WEATHER_SEASON_OPTIONS = [
  { value: 'winter' as const, descriptionKey: 'goodWeatherWinter' },
  { value: 'spring' as const, descriptionKey: 'goodWeatherSpring' },
  { value: 'summer' as const, descriptionKey: 'goodWeatherSummer' },
  { value: 'autumn' as const, descriptionKey: 'goodWeatherAutumn' },
] as const;

export type GoodWeatherDaylightValue = (typeof GOOD_WEATHER_DAYLIGHT_OPTIONS)[number]['value'];
export type GoodWeatherSeasonValue = (typeof GOOD_WEATHER_SEASON_OPTIONS)[number]['value'];
export type TYPE_ROOM_MODE_OPTIONS = {
  value: string;
  description: string;
};
export type ROOM_MODE_OPTION = (typeof ROOM_MODE_OPTIONS)[keyof typeof ROOM_MODE_OPTIONS];

export type ROOM_MODE_OPTION_VALUE = ROOM_MODE_OPTION['value'];
export type RoomMode = ROOM_MODE_OPTION_VALUE;

export const ROOM_MODE_OPTIONS_WITH_NO_CHECKBOXES: readonly string[] = [
  ROOM_MODE_OPTIONS.GOOD_WEATHER.value,
  ROOM_MODE_OPTIONS.ENHANCE_AND_UPSCALE.value,
  ROOM_MODE_OPTIONS.CLEAN_ROOM.value,
  ROOM_MODE_OPTIONS.FURNITURE_REMOVAL.value,
  ROOM_MODE_OPTIONS.PHOTOREALISTIC_FROM_3D.value,
];

export const roomModeOptions = [
  {
    value: ROOM_MODE_OPTIONS.FURNISH_EMPTY_ROOM,
    image: 'default-imagerendering-mode_FillEmptyRoom',
  },
  { value: ROOM_MODE_OPTIONS.CHANGE_STYLE, image: 'default-imagerendering-mode_ChangeStyle' },
  { value: ROOM_MODE_OPTIONS.CLEAN_ROOM, image: 'default-imagerendering-mode_CleanRoom' },
  {
    value: ROOM_MODE_OPTIONS.FURNITURE_REMOVAL,
    image: 'default-imagerendering-mode_EmptyFilledRoom',
  },
  {
    value: ROOM_MODE_OPTIONS.FINISH_CONSTRUCTION,
    image: 'default-imagerendering-mode_FinishConstruction',
  },
  { value: ROOM_MODE_OPTIONS.GOOD_WEATHER, image: 'default-imagerendering-mode_GoodWheater' },
  {
    value: ROOM_MODE_OPTIONS.ENHANCE_AND_UPSCALE,
    image: 'default-imagerendering-mode_ImproveQuality',
  },
  {
    value: ROOM_MODE_OPTIONS.PHOTOREALISTIC_FROM_3D,
    image: 'default-imagerendering-mode_Uprender',
  },
];
